import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Select from 'react-select';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import NoSsr from '@material-ui/core/NoSsr';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import CancelIcon from '@material-ui/icons/Cancel';
import { emphasize } from '@material-ui/core/styles/colorManipulator';

const styles = theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    overflow: 'auto',
  },
  input: {
    display: 'flex',
    padding: 0,
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
  },
  chip: {
    margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08,
    ),
  },
  noOptionsMessage: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 16,
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing.unit * 2,
  },
});

function NoOptionsMessage(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );
}

function Option(props) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function SingleValue(props) {
  return (
    <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
      {props.children}
    </Typography>
  );
}

function ValueContainer(props) {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

function MultiValue(props) {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      className={classNames(props.selectProps.classes.chip, {
        [props.selectProps.classes.chipFocused]: props.isFocused,
      })}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CancelIcon {...props.removeProps} />}
    />
  );
}

function Menu(props) {
  return (
    <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
      {props.children}
    </Paper>
  );
}

const components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};

class SearchSelect extends React.Component {
  state = {
    single: null,
    multi: "",
    suggestions: []
  };

  componentWillMount() {
      this.receiveData(this.props);
  }

  componentWillReceiveProps(nextProps) {
      this.receiveData(nextProps);
  }

  receiveData(nextProps){
      /* Met à jour les options du select */
      if(nextProps.options && nextProps.options.length > 0) {
          let data = nextProps.options.map(suggestion => ({
              value: suggestion.id,
              label: suggestion.reference + (suggestion.name ? " - " + suggestion.name : (suggestion.company && 'name' in suggestion.company) ? " - " +suggestion.company.name + " - " +suggestion.company.department : ""),
          }));
          this.setState({suggestions: data});
      }else if(nextProps.options.length === 0){
          this.setState({suggestions: []});
      }

      /* Pré-rempli le select */
      if(nextProps.defaultValue) {
          let data = nextProps.defaultValue.filter(val => {
              var arr = (nextProps.data) ? nextProps.data : nextProps.options;
              var opt = arr.find(opt => opt.id === val);

              return opt ? true : false;
          }).map(val => {
              var arr = (nextProps.data) ? nextProps.data : nextProps.options;
              var opt = arr.find(opt => opt.id === val);
              return {
                  value: opt.id,
                  label: opt.reference + (opt.name ? " - " + opt.name : (opt.company && 'name' in opt.company) ? " - " +opt.company.name + " - " +opt.company.department : ""),
              }
          });
          this.setState({multi: data});
      }
  }

  handleChange = (id, name) => val => {
    this.props.handleInputChange({target: {name:name, value: val.map(s => s.value)}})
    this.setState({
      [id]: val,
    });
  };

  render() {
    const { classes, theme, name, label, placeholder } = this.props;
    const selectStyles = {
      input: base => ({
        ...base,
        color: theme.palette.text.primary,
      }),
    };
    return (
      <div className={classes.root}>
        <NoSsr>
          <Select
            name={name}
            classes={classes.root}
            styles={selectStyles}
            textFieldProps={{
              label: label,
              InputLabelProps: {
                shrink: true,
              },
            }}
            options={this.state.suggestions}
            components={components}
            value={this.state.multi}
            onChange={this.handleChange("multi", name)}
            placeholder={placeholder}
            isMulti
          />
        </NoSsr>
      </div>
    );
  }
}

SearchSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(SearchSelect);



// WEBPACK FOOTER //
// ./src/component/utils/SearchSelect.js